export const setStorageItem = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch(err) {
    console.log(`setStorageItem error with ${key}`, err);
  }
}

export const getStorageItem = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || '""');
  } catch (err) {
    console.log(`getStorageItem error with ${key}`, err);
  }
}

export const removeStorageItem = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.log(`removeStorageItem error with ${key}`, err);
  }
}

export const clearStorageItem = () => {
  try {
    localStorage.removeItem("AuthenticationStore");
    localStorage.removeItem("MonetizationStore");
    localStorage.removeItem("CheckoutStore");
    localStorage.removeItem("routeState");
    localStorage.removeItem("isRedirected");
    localStorage.removeItem("transactionData");
    localStorage.removeItem("transactionUserList");
    localStorage.removeItem("SseStore");
    localStorage.removeItem("adobeConfig");
    localStorage.removeItem("BulkAssetMap");
    localStorage.removeItem("bulkContentMap");
    localStorage.removeItem("bulkEnitlementMap")
  } catch (err) {
    console.log(`clearStorageItem error`, err);
  }
}
